<template lang="pug">
div
  interessado-sicarf(
    :interessado="cadastro.interessado",
    :cadastrante="cadastro.cadastrante",
    :observer="observer",
    :hasSocios="true"
    :hasEspolio="true"
  )

  app-documentos(
    :maxSize='25',
    :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
    :documentos="cadastro.interessado.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorios"
    :observer="observer",
    aba="Interessado"
  )
</template>

<script>
import { mapActions } from 'vuex'
import InteressadoSicarf from '../../../../components/cadastro/InteressadoSicarf'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'

export default {
  props: ['cadastro', 'observer'],

  components: {
    InteressadoSicarf,
    AppDocumentos
  },

  data () {
    return {
      documentos: [],
      documentosObrigatorios: []
    }
  },

  async beforeRouteLeave (to, from, next) {
    await this.setDocumentosInteressado()
    await this.observer.validate({ providerName: 'Interessado/Documentos', skipIfEmpty: false })
    next()
  },

  async activated () {
    await this.setDocumentosInteressado()
  },

  computed: {
    interessado () {
      return this.cadastro.interessado
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    // Define a lista de documentos de acordo com o tipo de pessoa selecionado
    async setDocumentosInteressado () {
      if (this.cadastro.interessado.pessoa.tipo === 'PJ') {
        this.documentos = await this.findDocumentos('interessadoPj')
        this.documentosObrigatorios = await this.findDocumentos('obrigatorios/interessadoPj')
      } else {
        this.documentos = await this.findDocumentos('interessadoPf')
        this.documentosObrigatorios = await this.findDocumentos('obrigatorios/interessadoPf')

        if (this.interessado.pessoa.pessoaFisica.estadoCivil === 'VIUVO' && this.interessado.conjuge.pessoaFisica.possuiCertidaoObito) {
          const docsViuvo = await this.findDocumentos('obrigatorios/interessadoViuvo')
          this.documentos = [...this.documentos, ...docsViuvo]
          this.documentosObrigatorios = [...this.documentosObrigatorios, ...docsViuvo]
        } else if (this.interessado.pessoa.pessoaFisica.estadoCivil === 'CASADO') {
          const docsCasado = await this.findDocumentos('obrigatorios/interessadoCasado')
          this.documentos = [...this.documentos, ...docsCasado]
          this.documentosObrigatorios = [...this.documentosObrigatorios, ...docsCasado]
        } else if (this.interessado.pessoa.pessoaFisica.estadoCivil === 'UNIAO_ESTAVEL' || this.interessado.pessoa.pessoaFisica.estadoCivil === 'UNIAO_HOMOAFETIVA') {
          const docsUniao = await this.findDocumentos('obrigatorios/interessadoUniao')
          this.documentos = [...this.documentos, ...docsUniao]
          this.documentosObrigatorios = [...this.documentosObrigatorios, ...docsUniao]
        }
      }
    }
  },

  watch: {
    'interessado.pessoa.tipo': {
      async handler (val) {
        if (val === 'PJ') {
          this.documentos = await this.findDocumentos('interessadoPj')
          this.documentosObrigatorios = await this.findDocumentos('obrigatorios/interessadoPj')
        } else {
          this.documentos = await this.findDocumentos('interessadoPf')
          this.documentosObrigatorios = await this.findDocumentos('obrigatorios/interessadoPf')
        }

        this.observer.reset()
      }
    },

    'interessado.pessoa.pessoaFisica.estadoCivil': {
      async handler (val, oldval) {
        if (oldval) {
          await this.setDocumentosInteressado()
          this.$nextTick(async () => {
            await this.observer.validate({ providerName: 'Interessado/Documentos' })
          })
        }
      }
    },

    'interessado.conjuge.pessoaFisica.possuiCertidaoObito': {
      async handler (val, oldval) {
        if (oldval !== null && this.interessado.pessoa.tipo === 'PF') {
          await this.setDocumentosInteressado()
          this.$nextTick(async () => {
            await this.observer.validate({ providerName: 'Interessado/Documentos' })
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/resgateAforamento/components/Interessado.vue